<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 -->
        <el-form-item :label="$t('lang.lab_receivePeriod')">
          <el-date-picker  type="month" :placeholder="$t('lang.lab_startDate')"   value-format="timestamp" v-model="startTime"></el-date-picker>
            <span style="padding: 0 1px">至</span>
          <el-date-picker  type="month" :placeholder="$t('lang.lab_endDate')"  value-format="timestamp" v-model="endTime" ></el-date-picker>
        </el-form-item>
         <el-form-item >
          <el-select
            v-model="configId"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_receiveConfig"
          >
            <el-option
              key
              :label="$t('lang.lab_please_Select')+detail.lab_receiveConfig"
              value
            ></el-option>
            <el-option
              v-for="item in feeReceiveConfigs"
              :key="item.configId"
              :label="item.feeName"
              :value="item.configId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-switch style="margin-left: 10px; margin-right: 10px;" v-if="isRelationButton==1" active-text="收费减免" v-model="switchValue"> </el-switch>
        <!-- 关键字 -->
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
         :summary-method="getSummaries"
          show-summary
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="55"
        ></el-table-column>
        <!-- 用户名 -->
        <el-table-column width="100" prop="ownerName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile" width="120" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="gardenName"  width="100" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column  prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column  prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 建筑面积 -->
        <el-table-column prop="buildArea" :label="$t('lang.lab_preHouseholdArea')"></el-table-column>
        <el-table-column prop="fee_name" :label="$t('lang.feePay.lab_feeConfigName')"></el-table-column>
  
       
        <el-table-column  prop="end_time" width="110" :label="$t('lang.lab_startTimes')">
          <template slot-scope="scope">{{scope.row.end_time|timeYMD}}</template>
        </el-table-column>
        <!-- 当前欠款 -->
        <el-table-column prop="payCount" :label="$t('lang.lab_currentYearArrear')">
          <template slot-scope="scope">{{scope.row.payCount|rounding}}</template>
        </el-table-column>
        <el-table-column prop="thisPayPeriod" width="150" :label="$t('lang.lab_thisArrearsTime')"></el-table-column>
         <!-- 往期欠款 -->
        <el-table-column prop="pastCount" :label="$t('lang.lab_yearPastArrear')">
          <template slot-scope="scope">{{scope.row.pastCount|rounding}}</template>
        </el-table-column>
          <!-- 费用间 -->
        <el-table-column prop="payPeriod" width="150" :label="$t('lang.lab_arrearsTime')"></el-table-column>
      </el-table>
    
    </el-card>
  </div>
</template>

<script>
  import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description
 *@author:xubz
 *@Copyright:格众科技
 *@date:2021
 */
export default {
  data() {
    return {
      isRelationButton:this.$store.getters.isRelationButton,
      switchValue:false,
      multipleSelection: [], // 多选框
      editableTabs: [], // tabs列表
      datevalues: [], // 开始结束时间绑定值
      houseId: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '0', // 标签
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      gardenId: '', // 小区编号
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
      receiveArrearSelects: this.$i18n.t('lang.lab_receiveArrearSelect'), // 标签列表
      appHouseholdManageListcheckbox: require('@/config/enum')
      .appHouseholdManageListcheckbox, // 是否隐藏复选框
      receiveAmountCount: '',
      revAmountCount: '',
      paidAmountCount: '',
      receiveArrearSelect: '0',
      startTime: '',
      endTime: '',
      feeReceiveConfigs:[],
      detail: this.$i18n.t('lang.feePay'), // 列表数据 xu
      configId:''
    }
  },
  created() {
    // 小区编号
    this.gardenId = this.$store.getters.gardenId
    this.getDatePicker()
    this.feeReceiveConfigList();
    // 初始化
    // this.topics()
    // 获取楼号
    this.gardenGrids(this.gardenId)
    this.editableTabs = this.$store.getters.getTabList
  },
  // 监听改变小区编号
  watch: {
    '$store.state.allGardenId': function (newFlag, oldFlag) {
      this.gardenId = this.$store.state.allGardenId
      this.gardenChange()
    },
    '$store.state.tabList': function (newFlag, oldFlag) {
      this.editableTabs = this.$store.getters.getTabList
    },
  },
  methods: {
    excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.resourUnit'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_preHouseholdArea'),
            this.$i18n.t('lang.feePay.lab_feeConfigName'),
            this.$i18n.t('lang.lab_startTimes'),
            this.$i18n.t('lang.lab_currentYearArrear'),
            this.$i18n.t('lang.lab_thisArrearsTime'),
            this.$i18n.t('lang.lab_yearPastArrear'),
            this.$i18n.t('lang.lab_arrearsTime'),
          ]
          let newArr = []
          let end_time = ''
          let payCount = ''
          let pastCount = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].end_time) {
                end_time = this.$options.filters['timeYMD'](this.tableData[i].end_time)
              }
                payCount = this.$options.filters['rounding'](this.tableData[i].payCount)
                pastCount = this.$options.filters['rounding'](this.tableData[i].pastCount)
              newArr.push({
                'ownerName': this.tableData[i].ownerName,
                'mobile': this.tableData[i].mobile,
                'gardenName': this.tableData[i].gardenName,
                'houseName': this.tableData[i].houseName,
                'unitName': this.tableData[i].unitName,
                'roomName': this.tableData[i].roomName,
                'buildArea': this.tableData[i].buildArea,
                'fee_name': this.tableData[i].fee_name,
                'end_time': end_time,
                'payCount': payCount,
                'thisPayPeriod': this.tableData[i].thisPayPeriod,
                'pastCount':pastCount,
                'payPeriod': this.tableData[i].payPeriod
              })
            }
          }


          // 对应table数据的列字段名
          const filterVal = ['ownerName', 'mobile', 'gardenName', 'houseName', 'unitName', 'roomName', 'buildArea',
          'fee_name','end_time','payCount','thisPayPeriod','pastCount','payPeriod'
          ]
          excelDownload(tHeader, filterVal, newArr, "欠费统计表")
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
     getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          if(index==10||index==11){
          const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return parseFloat(prev) + parseFloat(curr);
                } else {
                  return prev;
                }
              }, 0);
              sums[index]=sums[index].toFixed(2);
            } else {
              sums[index] = '';
            }
          }
        });  
          
          

        return sums;
      },
    // 初始化时间组件
    getDatePicker() {
       let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
      let date1 = new Date(year1, month1, day1).getTime()
      // this.datevalues.push(Date.parse(date1))
      this.endTime = date1
      // 前一天设定的日期时间
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2).getTime()
      // this.datevalues.unshift(Date.parse(date2))
       this.startTime = date2
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 改变小区
    gardenChange() {
      this.houseId = ''
      this.topics()
      this.unitid = ''
      this.roomid = ''
      this.unitList = ''
      this.roomList = ''
      this.type = 1
      this.gardenGrids(this.gardenId)
    },
    // 获取楼号单元号房间号
    gardenGrids(parentId) {
      let loading = this.$loading()
      this.$get(
        `/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.floorList = res.list
            } else if (this.type === 2) {
              this.unitList = res.list
              this.roomList = ''
              if (this.houseId === '') {
                this.unitList = ''
                this.roomList = ''
              }
            } else if (this.type === 3) {
              this.roomList = res.list
              if (this.unitid === '') {
                this.roomList = ''
              }
            }
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
     feeReceiveConfigList() {
      debugger
      console.log(this.gardenId)
      let loading = this.$loading()
      let params = {
        gardenId: this.gardenId,
      }
      this.$get(`/feeReceiveConfigList/`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.feeReceiveConfigs = res.list
            this.configId=res.list[0].configId
          }
          this.topics()
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
      
    },
    topics() {
      var startTs = ''
      var endTs = ''
      var configId=this.configId
      if(this.startTime!=''&&this.startTime!=null&&this.startTime!=undefined){
           startTs =this.startTime
      }else{
           this.$message.info('应收区间不能为空')
          return
      }
       if(this.endTime!=''&&this.endTime!=null&&this.endTime!=undefined){
           endTs =this.endTime
      }else{
          this.$message.info('应收区间不能为空')
          return
      }
      let loading = this.$loading()
      this.$get(
        `/feeReceiveArrearsListByGardenId?gardenId=${this.gardenId}&configId=${configId}&startTs=${startTs}&endTs=${endTs}&isWaiver=${this.switchValue}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.receiveAmountCount = ''
            this.revAmountCount = ''
            this.paidAmountCount = ''
            console.log(res.list)
            this.tableData = res.list
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 提交
    submit() {
      this.pageNo = 1
      this.topics()
    },
    // 通过楼层选择单元号
    selectUnit() {
      this.type = 2
      this.gardenGrids(this.houseId)
      this.unitid = ''
      this.roomid = ''
    },
    // 通过单元选择房间号
    selectRoom() {
      this.type = 3
      this.gardenGrids(this.unitid)
      this.roomid = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    },
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == '') {
          value = 0
      }
     return value.toFixed(2)
    }
  }
}
</script>

<style lang= 'scss'>
</style>
